import { createSelector } from 'reselect';

import { selectLocations } from 'entities/location/selectors';
import type { State } from 'reducers';
import type { UserState } from 'entities/user/reducer';

export const selectUser = (state: State): UserState => state.get('entities').user;

export const selectOrganization = createSelector(selectUser, (user) => user?.organization);

export const selectUserLocations = createSelector(
  selectUser,
  selectLocations,
  (user, locations) => {
    const organizationLocations = user?.organization?.locations;
    return organizationLocations && organizationLocations.size > 0
      ? organizationLocations
      : locations;
  }
);

export const selectAccessibleUserLocations = createSelector(
  selectUser,
  selectUserLocations,
  (user, userLocations) => {
    if (user?.locations?.size) {
      return userLocations.filter((location) =>
        user.locations.find((userLocation) => userLocation.id === location?.id)
      );
    }
    return userLocations;
  }
);

export const selectVolunteerRewardValidationForm = createSelector(
  selectOrganization,
  (organization) => organization?.settings?.get('volunteerReward')?.validationForm
);
